module.exports = __webpack_public_path__ + "static/img/404.aff8a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.jpg
// module id = kvT1
// module chunks = 1